module.exports = __webpack_public_path__ + "img/tiktok.0a431773.svg";